var cov_1z9sw8z9vv = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Alert/styles/index.ts",
      hash = "e042044aa6b64fcf5a281365c0a87237524f3e3b",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Alert/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 26
        },
        end: {
          line: 5,
          column: 56
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


import genaration from '../../utils/classname';
var alertLess = {};
export var alertClass = (cov_1z9sw8z9vv.s[0]++, genaration(alertLess, 'alert'));